<template>
  <div class="excel">
    <v-container fluid>
      <v-tabs v-model="tab">
        <v-tabs-slider color="pink"></v-tabs-slider>
        <v-tab>Node Description</v-tab>
        <v-tab>Link</v-tab>
        <v-tab>Reference</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="mt-5">
        <v-tab-item>
          <v-data-table
            dense
            :headers="nodeHeaders"
            :items="nodeItems"
            :items-per-page="20"
            class="elevation-1"
          ></v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            dense
            :headers="linkHeaders"
            :items="linkItems"
            :items-per-page="20"
            class="elevation-1"
          ></v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            dense
            :headers="referenceHeaders"
            :items="referenceItems"
            :items-per-page="20"
            class="elevation-1"
          ></v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import { db } from '../firebase/init'
import moment from 'moment'

export default {
  name: 'Excel',
  data () {
    return {
      // items: null,
      tab: null,
      nodeHeaders: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        { text: 'class', value: 'class' },
        { text: 'groupName', value: 'groupName' },
        { text: 'partName', value: 'partName' },
        { text: 'label', value: 'label' },
        { text: 'hangeul', value: 'hangeul' },
        { text: 'hanja', value: 'hanja' },
        { text: 'english', value: 'english' },
        { text: 'infoUrl', value: 'infoUrl' },
        { text: 'iconUrl', value: 'iconUrl' },
        { text: 'note', value: 'note' },
        { text: 'remark', value: 'remark' },
        // { text: 'timestamp', value: 'timestamp' },
      ],
      nodeItems: [],

      linkHeaders: [
        {
          text: 'source',
          align: 'start',
          value: 'source',
        },
        { text: 'target', value: 'target' },
        { text: 'relation', value: 'relation' },
        { text: 'attribute', value: 'attribute' },
        { text: 'timestamp', value: 'timestamp' }
      ],
      linkItems: [],

      referenceHeaders: [
        {
          text: '해당 위키 표제어',
          align: 'start',
          value: 'wikiTitle',
        },
        { text: 'class', value: 'class' },
        { text: 'type', value: 'type' },
        { text: 'resource', value: 'resource' },
        { text: 'title', value: 'title' },
        { text: 'description/caption', value: 'descriptionCaption' },
        { text: 'infoUrl', value: 'infoUrl' },
      ],
      referenceItems: [],
    }
  },
  computed: {

  },
  created(){
    db.collection('items').orderBy('timestamp', 'desc').get().then(snapshot => {
      let items = [];
      snapshot.forEach(doc => {
        let item = doc.data();
        item.id = doc.id;
        items.push(item);
        this.items = items;

        let remark = ''
        if(item.birthYear || item.deathYear) {
          remark = `【${item.birthYear}~${item.deathYear}】. ${item.content}`
        } else {
          remark = item.content
        }

        // Node Description
        this.nodeItems.push({
          id: item.nodeDescription.id,
          class: item.nodeDescription.class,
          groupName: item.nodeDescription.groupName,
          prartName: item.nodeDescription.prartName,
          label: item.nodeDescription.label,
          hangeul: item.nodeDescription.hangeul,
          hanja: item.nodeDescription.hanja,
          english: item.nodeDescription.english,
          infoUrl: item.nodeDescription.infoUrl,
          iconUrl: item.nodeDescription.iconUrl,
          note: item.user.name,
          remark: remark,
          timestamp: moment(item.timestamp).format('YYYY-MM-DD')
        });

        // link
        // item.relations.forEach(relation => {
        //   let link = {
        //     source: relation.source,
        //     target: relation.target,
        //     relation: relation.relation,
        //     attribute: '',
        //     timestamp: item.timestamp
        //   };
        //   this.linkItems.push(link)
        // })

        // Reference
        // item.references.forEach(ref => {
        //   let reference = {
        //     wikiTitle: item.titleK,
        //     class: "WebResource",
        //     type: ref.type,
        //     resource: ref.resource,
        //     title: ref.title,
        //     descriptionCaption: "",
        //     infoUrl: ref.url
        //   };
        //   this.referenceItems.push(reference)
        // })
      })
    })
  }
};
</script>

<style>
td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>

